import NowPlayingCardControls from './NowPlayingCardControls';

export default NowPlayingCardControls;
